import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import { appInsightsLoggerPlugin } from '@core/plugins/appInsights';
import App from './App.vue';
import { router } from './routing';
import millersEventsPlugin from './millersEventsPlugin';
import './index.css';
import 'vue-toastification/dist/index.css';
import 'floating-vue/dist/style.css';
import 'vue3-perfect-scrollbar/style.css';

const app = createApp(App);

app.use(router);
app.use(createPinia());
app.use(PerfectScrollbarPlugin);
app.use(millersEventsPlugin);
if (import.meta.env.VITE_APPINSIGHTS_CONN) {
  app.use(appInsightsLoggerPlugin, {
    connectionString: import.meta.env.VITE_APPINSIGHTS_CONN,
  });
}

app.mount('#app');
